import { WebSocketSendRequestDataMessage } from './web-socket-send-request-data-message';

/**
 * {
 *   "action": "DATA_REQUEST",
 *   "entityId": 420420,
 *   "payload": {
 *     "companyId": 170479,
 *     "locationId": 420420,
 *     "requestId": "asd123",
 *     "userId": "user-id-here",
 *     "dataType": "WebsocketDataRequestType_Template",
 *     "metadata": "metadata": {
 *       "Id": "",
 *       "Source": "Dashboard"
 *     }
 *   }
 * }
 */
export class WebSocketRequestTemplate extends WebSocketSendRequestDataMessage {
  constructor(locationId: number, id: string) {
    super();
    this.payload.locationId = locationId;
    this.payload.dataType = 'WebsocketDataRequestType_Template';
    this.payload.metadata = {
      Id: id,
      Source: 'Display'
    };
  }
}
